module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAYAAACaq43EAAAABGdBTUEAALGPC/xhBQAAAMFJREFUSA3V1MENgjAYxXE8encCL07gBMzjCJ5cgh1cwXm8cuNa/zV+0IA2LX3V2OSltCTvBySlaX49nHNbciIb9bPQeSTtopdNj96IHx2R4XR5tCcDmXAWIcryOSQ4TYa+agOcnT25251gLsLpmaNWfR4/OTsHIsMj6GVE7UKFZ6EqfBVaiheha3EJmotL0VS8CpqAX4H9H2k+lkfGynJnmj+d83qoPWQCrntTQ22O4PXQCF4ffYN/Dw3wnV3/1fwAojPZQc/EWUkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/arrow-down.png
// module id = 584
// module chunks = 35783957827783